/* VANTEK · Retiro en tienda Parque Arauco
   - Calcula "Retira hoy/mañana desde las HH:MM" en hora de Chile (America/Santiago), sin importar la zona del dispositivo.
   - Reglas en los data-* del bloque [data-vt-retiro] (ver snippets/vantek-retiro.liquid).
   - Pop-up (<dialog>) creado una sola vez en <body> desde el <template> del bloque.
   - Repinta al cambiar de variante (evento afterVariantChanged del tema) y cada minuto. */
(function () {
  if (window.__vtRetiro) return;
  window.__vtRetiro = true;

  var dlg = null;

  function nowChile() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'America/Santiago', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      var h = 0, m = 0;
      parts.forEach(function (p) { if (p.type === 'hour') h = +p.value % 24; if (p.type === 'minute') m = +p.value; });
      return h * 60 + m;
    } catch (e) { var d = new Date(); return d.getHours() * 60 + d.getMinutes(); }
  }
  function hhmm(m) { var h = Math.floor(m / 60), mm = m % 60; return (h < 10 ? '0' : '') + h + ':' + (mm < 10 ? '0' : '') + mm; }
  function num(el, k, def) { var v = parseInt(el.getAttribute('data-' + k), 10); return isNaN(v) ? def : v; }

  function calc(el) {
    var OPEN = num(el, 'open', 600), CLOSE = num(el, 'close', 1200), PREP = num(el, 'prep', 240), NEXT = num(el, 'next', 660);
    var now = nowChile();
    var ready = now < OPEN ? NEXT : Math.ceil((now + PREP) / 30) * 30;
    if (now < CLOSE && ready <= CLOSE) return { today: true, text: 'Retira hoy desde las ' + hhmm(ready) };
    return { today: false, text: 'Retira mañana desde las ' + hhmm(NEXT) };
  }

  function paint() {
    var blocks = document.querySelectorAll('[data-vt-retiro]');
    if (!blocks.length) return;
    var r = calc(blocks[0]);
    for (var i = 0; i < blocks.length; i++) {
      blocks[i].classList.toggle('is-tomorrow', !r.today);
      var w = blocks[i].querySelector('[data-vt-retiro-when]');
      if (w && w.textContent !== r.text) w.textContent = r.text;
    }
    if (dlg) { var s = dlg.querySelector('[data-vt-retiro-when]'); if (s && s.textContent !== r.text) s.textContent = r.text; }
  }

  function ensureDialog() {
    if (dlg) return dlg;
    var tpl = document.querySelector('[data-vt-retiro] template[data-vt-retiro-tpl]');
    if (!tpl) return null;
    dlg = tpl.content.firstElementChild.cloneNode(true);
    document.body.appendChild(dlg);
    dlg.querySelector('[data-vt-store-close]').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    return dlg;
  }

  function open() {
    var d = ensureDialog();
    if (!d) return;
    paint();
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
  }

  function init() {
    paint();
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-vt-retiro-open]');
      if (t) { e.preventDefault(); open(); }
    });
    document.addEventListener('afterVariantChanged', function () { setTimeout(paint, 0); });
    setInterval(paint, 60000);
    /* Respaldo: si el tema reemplaza el bloque sin disparar el evento, repintar al detectar uno nuevo */
    if (window.MutationObserver) {
      var t = null;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(paint, 50); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
